export default __webpack_public_path__ + "static/media/awoo.73afe64e.gif";